/* unplugin-vue-components disabled */import script from "./OrdinaryDouyinGame.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrdinaryDouyinGame.vue?vue&type=script&setup=true&lang=ts"

import "./OrdinaryDouyinGame.vue?vue&type=style&index=0&id=df00a158&scoped=true&lang=less"
import "./OrdinaryDouyinGame.vue?vue&type=style&index=1&id=df00a158&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df00a158"]])

export default __exports__